import { render } from "./DisplayLayout.vue?vue&type=template&id=01b09f4f"
import script from "./DisplayLayout.vue?vue&type=script&lang=js"
export * from "./DisplayLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__